
import React from 'react';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import { useProgressAnimation } from '@/hooks/useProgressAnimation';

interface LearningProgressProps {
  currentExerciseIndex: number;
  totalExercises: number;
  progress: number;
  isRecycledWord?: boolean;
}

const LearningProgress = ({ 
  currentExerciseIndex, 
  totalExercises, 
  progress,
  isRecycledWord = false 
}: LearningProgressProps) => {
  // Use our reusable progress animation hook
  const { animatedProgress } = useProgressAnimation({
    progress,
    duration: 800,
    preventBackwards: true,
    skipIfRecycled: true,
    isRecycled: isRecycledWord
  });
  
  return (
    <div className="space-y-1">
      <Progress 
        value={animatedProgress} 
        className="h-3 bg-muted/50 overflow-hidden rounded-full" 
        indicatorClassName="bg-primary" 
      />
      <div className="flex justify-between text-xs text-muted-foreground mt-1">
        <span className={cn(
          "font-medium",
          animatedProgress >= 99.5 && "text-primary"
        )}>
          Exercise {currentExerciseIndex} of {totalExercises}
        </span>
        <span className={cn(
          "font-medium",
          animatedProgress >= 99.5 && "text-primary"
        )}>
          {Math.round(animatedProgress)}% complete
        </span>
      </div>
    </div>
  );
};

export default LearningProgress;
